import _ from "lodash";

import { STANDARD_BASED_RUBRIC } from "Constants/stringConstants";
import { STANDARD_UIDS } from "modules/AssessmentTool/Constants";

const STANDARD_FIELD_UIDS = new Set(Object.values(STANDARD_UIDS));
const EMPTY_IDS_SET = new Set();

export const getStandardRubricCoveredNodeIds = ({
  assessmentTools,
  isNewGradingSetupEnabled,
}) => {
  if (!isNewGradingSetupEnabled) return EMPTY_IDS_SET;

  const edges = _.get(assessmentTools, "edges", []);
  if (_.isEmpty(edges)) return EMPTY_IDS_SET;

  const rubricEdges = _.filter(edges, ({ node }) => {
    return _.get(node, "assessmentToolType") === STANDARD_BASED_RUBRIC;
  });

  if (_.isEmpty(rubricEdges)) return EMPTY_IDS_SET;

  const ids = _.flatMap(rubricEdges, ({ node }) =>
    _.compact(
      _.map(
        _.get(node, "assessmentToolItem.standardRubricCriterias", []),
        criteria =>
          _.get(criteria, "standard.id") || _.get(criteria, "benchmark.id")
      )
    )
  );

  return _.isEmpty(ids) ? EMPTY_IDS_SET : new Set(ids);
};

// we are filtering out standards that were already added in standard based rubric...
export const syncAssessmentFieldsWithStandardRubric = ({
  assessmentFields,
  standardRubricCoveredNodeIds,
}) => {
  if (
    _.isEmpty(assessmentFields) ||
    !standardRubricCoveredNodeIds ||
    standardRubricCoveredNodeIds.size === 0
  ) {
    return assessmentFields;
  }

  return _.map(assessmentFields, field => {
    const uid = _.get(field, "uid");
    if (!STANDARD_FIELD_UIDS.has(uid)) return field;

    const key = uid === "benchmarks" ? "benchmarks" : "nodes";
    const nodes = _.get(field, `resolvedMinimalTree.${key}`);
    if (!_.isArray(nodes)) return field;

    const filteredNodes = _.filter(
      nodes,
      node => !standardRubricCoveredNodeIds.has(node.id)
    );

    const values = _.get(field, "value", []);
    const filteredValues = _.filter(
      values,
      id => !standardRubricCoveredNodeIds.has(id)
    );

    const isUnchanged =
      filteredNodes.length === nodes.length &&
      filteredValues.length === (values || []).length;

    if (isUnchanged) return field;

    return {
      ...field,
      value: filteredValues,
      resolvedMinimalTree: {
        ...field.resolvedMinimalTree,
        [key]: filteredNodes,
      },
    };
  });
};
